/**
 * Localized URLs for marketing/legal pages on www.folw.eu (aligned with mobile app).
 */
export function localizedFolwMarketingPageUrl(languageCode: string, page: string): string {
  const lc = languageCode.toLowerCase();
  if (lc === 'en') {
    return `https://www.folw.eu/en/${page}`;
  }
  if (lc === 'tr') {
    return `https://www.folw.eu/tr/${page}`;
  }
  return `https://www.folw.eu/${page}`;
}
